import { getCurrentSession } from '../../../lib/authentication';

export const savePreferences = ({ id, ...rest }) => {
    return getCurrentSession().then(result => {
        const { accessToken } = result;
        return apigClient.usersIdPreferencesPost(
            { id },
            rest,
            {
                headers: {
                    Authorization: accessToken
                }
            }
        );
    });
};

export const deletePreferences = ({ id }) => {
    return getCurrentSession().then(result => {
        const { accessToken } = result;
        return apigClient.usersIdPreferencesDelete(
            { id },
            {},
            {
                headers: {
                    Authorization: accessToken
                }
            }
        );
    });
};
